<template>
  <li :class="[role?.team, role?.selected ? 'selected' : '']" @click="emit('toggle', role)">
    <Token :role="role" :unchecked="!role?.selected" />
    <font-awesome-icon v-if="role?.setup" icon="exclamation-triangle" class="fa fa-exclamation-triangle" />
    <div v-if="hasBagDuplicate || multipleAllowed" class="buttons">
      <font-awesome-icon icon="minus-circle" @click.stop="emit('decrement', role)" />
      <span>{{ role?.selected > 1 ? "x" + role?.selected : "" }}</span>
      <font-awesome-icon icon="plus-circle" class="fa fa-plus-circle" @click.stop="emit('increment', role)" />
    </div>
  </li>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { Token } from "@/components";
import { usePlayersStore } from "@/stores";
import type { SelectableRole } from "@/types";

const props = defineProps<{
  role: SelectableRole;
  multipleAllowed?: boolean | undefined;
}>();

const emit = defineEmits<{
  toggle: [role: SelectableRole];
  increment: [role: SelectableRole];
  decrement: [role: SelectableRole];
}>();

const playersStore = usePlayersStore();

const hasBagDuplicate = computed(() => playersStore.hasFeature(props.role, "bag-duplicate"));
</script>

<style scoped lang="scss">
li {
  &.selected {
    .buttons {
      display: flex;
    }

    .fa-exclamation-triangle {
      display: block;
    }
  }

  .fa-exclamation-triangle {
    position: absolute;
    color: red;
    text-shadow: 0 0 2px black;
    filter: drop-shadow(0 0 3px black);
    top: 5px;
    right: -5px;
    font-size: 150%;
    display: none;
  }

  .buttons {
    display: none;
    position: absolute;
    top: 95%;
    text-align: center;
    width: 100%;
    z-index: 30;
    font-weight: bold;
    filter: drop-shadow(0 0 5px rgba(0, 0, 0, 1));

    span {
      flex-grow: 1;
    }

    svg {
      opacity: 0.25;
      cursor: pointer;

      &:hover {
        opacity: 1;
        color: red;
        text-shadow: 0 0 2px black;
      }
    }
  }
}
</style>
